import { render, staticRenderFns } from "./AdvantagesItem.vue?vue&type=template&id=22f2528e&scoped=true"
import script from "./AdvantagesItem.vue?vue&type=script&lang=js"
export * from "./AdvantagesItem.vue?vue&type=script&lang=js"
import style0 from "./AdvantagesItem.vue?vue&type=style&index=0&id=22f2528e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2528e",
  null
  
)

export default component.exports